import { useState } from 'react'
import { InputNumber, Slider } from 'antd'

import {
  DIRECTION,
  DISTANCE,
  HORIZONTAL,
  ROLL,
  VERTICAL,
} from '../data'
import './index.less'

interface ISliderItemProps {
  name: string
  value: number
  sliderConfig: any
  valueChangeCallback: (name: string, value: number | null) => void
}
const prefix = 'slider-item'

function SliderItem(props: ISliderItemProps) {
  const { name, value: propsValue, sliderConfig, valueChangeCallback } = props
  const [value, setValue] = useState(propsValue)

  const SliderComponent = () => {
    const directionChange = (value: number | null) => {
      switch (name) {
        case DIRECTION:
          setValue(value || 0)
          break
        case ROLL:
          setValue(value || 0)
          break
        case DISTANCE:
          setValue(value || 0)
          break
        case HORIZONTAL:
          setValue(value || 0)
          break
        case VERTICAL:
          setValue(value || 0)
          break
        default:
          break
      }
      valueChangeCallback(name, value)
    }
    return <div className={`${prefix}-box3-one-item`}>
      <div>
        <Slider
          min={0}
          max={360}
          onChange={directionChange}
          value={value}
          {...sliderConfig}
        />
      </div>
      <div>
        <InputNumber
          min={0}
          max={360}
          value={value}
          onChange={directionChange}
          {...sliderConfig}
        />
      </div>
    </div>
  }
  return <>
  {SliderComponent()}
  </>
}
export default SliderItem
